import { render, staticRenderFns } from "./ClpFacetItem.vue?vue&type=template&id=2af7a826&scoped=true&"
import script from "./ClpFacetItem.vue?vue&type=script&lang=js&"
export * from "./ClpFacetItem.vue?vue&type=script&lang=js&"
import style0 from "./ClpFacetItem.vue?vue&type=style&index=0&id=2af7a826&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af7a826",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImg: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppImg.vue').default,CmsRichText: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsRichText.vue').default})
